<template>
  <div class="shoppingCart">
    <div
      class="show-hide"
      :class="{'active':visible}"
      @click="show('right')"
      ref="showhide"
    >
      <span class="total-number">
        {{ productQuantity }}
      </span>
      <img src="../../assets/shoppingCart.png" alt="err">
    </div>
    <rj-drawer
      v-model="visible"
      :title="$t('addConfigModule.productAdded')"
      width="420"
      placement="right"
    >
      <div
        class="series-content"
        v-for="(item,j) in groupSubItemDListVOList"
        :key="j"
      >
        <div class="series">
          <input
            type="checkbox"
            v-model="checkedList"
            :value="item.subId"
            @click="checkSubAllItem(item,$event)"
          >
          <span class="series-name">
            {{ item.productSeriesName }}
          </span>
        </div>
        <div
          class="version-content"
          v-for="(por,i) in item.productItems"
          :key="i"
        >
          <div class="version">
            <input
              style="margin-left: 3px"
              type="checkbox"
              v-model="checkedItemList"
              :value="por.itemId"
              @change="clickSubItem(item,$event)"
            >
            <span class="version-name">
              {{ por.productName }}
            </span>
            <div class="version-number">
              <span class="number">
                {{ $t('addConfigModule.theNumber') }}:</span>
              <el-input-number
                size="mini"
                :min="1"
                :precision="0"
                :max="por.optionalType === 1 &&
                  por.subPropertyName === '主机' ? 1 : 99999"
                v-model="por.purchaseQuantity"
              >
                {{ por.purchaseQuantity }}
              </el-input-number>
              <div class="del-icon">
                <i class="el-icon-delete" @click="deleteProductItem(por.itemId)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="operation">
        <input type="checkbox" v-model="checked" @click="checkAll">
        <span class="select-text">
          {{ $t('addConfigModule.selectAll') }}
        </span>
        <el-button
          style="margin-left: 10px"
          type="danger"
          round
          plain
          :disabled="checkedList.length<1 &&
            checkedItemList.length<1"
          @click="deleteGroupSubs"
        >
          {{ $t('addConfigModule.delete') }}
        </el-button>
        <el-button
          type="primary"
          style="margin-left: 10px"
          round
          plain
          @click="saveProduct"
        >
          {{ $t('addConfigModule.save') }}
        </el-button>
        <el-button
          style="margin-left: 10px"
          type="info"
          round
          plain
          @click="added"
        >
          {{ $t('addConfigModule.deconfigure') }}
        </el-button>
      </div>
    </rj-drawer>
  </div>
</template>

<script type="es6">
import Api from '../../api';
import eventBus from '../../utils/eventBus';
export default {
  name: 'ShoppingCart',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    configurationGroup: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      placement: 'left',
      groupSubItemDListVOList: [],
      groupNameT: '',
      checkedList: [],
      checkedItemList: [],
      checked: false,
      productQuantity: 0
    };
  },
  components: {

  },
  mounted () {
    eventBus.$on('getProductQuantity', () => {
      this.getProductQuantity();
    });
  },
  destroyed () {
    eventBus.$off('getProductQuantity');
    document.querySelector('body').removeAttribute('style');
  },
  methods: {
    loadData () {
      let param = {
        params: {
          groupId: this.configurationGroup.groupId,
          groupName: this.configurationGroup.groupName,
          projectId: this.configurationGroup.projectId
        }
      };
      Api.getGroupProductList(param)
        .then(res => {
          let { status, data } = res.data;
          if (status === '200') {
            this.groupSubItemDListVOList = data.list;
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    show () {
      this.visible = !this.visible;
      this.scollHight();
      this.loadData();
    },
    scollHight () {
      this.$nextTick(function () {
        // var div = document.getElementsByClassName('rj-drawer__body')[0];
        // div.scrollTop = div.scrollHeight;
      });
    },
    // 只保存操作
    saveProduct () {
      let body = {
        groupId: this.configurationGroup.groupId,
        groupSubItemDListVOList: this.groupSubItemDListVOList
      };
      Api.saveConfigProduct(body)
        .then(result => {
          if (result.data.status === '200') {
            // this.loadData();
            this.getProductQuantity();
            this.$notify.success(this.$t('addConfigModule.saveSucceeded'));
          }else if(json.status === '10002'|| json.status ==="10067"
              || json.status ==="10068" || json.status ==="10069" || json.status ==="10070" 
              || json.status ==="10071" || json.status ==="10072" || json.status ==="10073"
              ){
                this.$notify.error(json.err);
                this.isDisabled = false;
              }else {
            this.$notify.error(result.data.msg);
          }
        })
        .catch(e => {
          this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
        });
    },
    deleteProductItem (itemId) {
      this.$confirm(this.$t('addConfigModule.deleteSelecedProductsMsg'), this.$t('addConfigModule.prompt'), {
        confirmButtonText: this.$t('addConfigModule.determine'),
        cancelButtonText: this.$t('addConfigModule.cancel'),
        type: 'warning'
      }).then(() => {
        let param = {
          params: {
            itemId: itemId
          }
        };
        Api.deleteProductItem(param)
          .then(result => {
            if (result.data.status === '200') {
              this.loadData();
              this.getProductQuantity();
            } else {
              this.$notify.error(result.data.msg);
            }
          })
          .catch(e => {
            console.error('error', e);
            this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('addConfigModule.hasBeenDelete')
        });
      });
    },
    deleteGroupSubs () {
      this.$confirm(this.$t('addConfigModule.deleteSelecedXlAndProductsMsg'), this.$t('addConfigModule.prompt'), {
        confirmButtonText: this.$t('addConfigModule.determine'),
        cancelButtonText: this.$t('addConfigModule.cancel'),
        type: 'warning'
      }).then(() => {
        Api.deleteGroupSub({
          projectId: this.configurationGroup.projectId,
          subIds: this.checkedList,
          itemIds: this.checkedItemList
        }).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.getProductQuantity();
            this.$notify.success(this.$t('addConfigModule.deleteSucceeded'));
            this.loadData();
            this.clearChecked();
          }
        }).catch(e => {
          this.clearChecked();
          this.loading = false;
          console.error(e);
        });
      }).catch(() => {
        this.clearChecked();
        this.$message({
          type: 'info',
          message: this.$t('addConfigModule.hasBeenDelete')
        });
      });
    },
    clearChecked () {
      this.checkedList = [];
      this.checkedItemList = [];
      this.checked = false;
    },
    added () {
      this.$parent.saveStatus();
      this.$router.push({
        name: 'AddedProduct/added',
        params: {
          groupId: this.configurationGroup.groupId,
          projectId: this.configurationGroup.projectId,
          isService: this.configurationGroup.isService }
      });
    },
    checkAll () {
      let _this = this;
      if (_this.checked) { // 实现反选
        _this.checkedList = [];
        _this.checkedItemList = [];
      } else { // 实现全选
        _this.checkedList = [];
        _this.checkedItemList = [];
        _this.groupSubItemDListVOList.forEach(function (item, index) {
          _this.checkedList.push(item.subId);
          item.productItems.forEach(prod => {
            _this.checkedItemList.push(prod.itemId);
          });
        });
      }
    },
    checkSubAllItem (sub, $event) {
      let checked = $event.target.checked;
      let that = this;
      if (checked) {
        // 全选
        sub.productItems.forEach(item => {
          if (that.checkedItemList.indexOf(item.itemId) < 0) {
            that.checkedItemList.push(item.itemId);
          }
        });
      } else {
        // 反选
        sub.productItems.forEach(item => {
          that.checkedItemList.splice(that.checkedItemList.indexOf(item.itemId), 1);
        });
      }
    },
    clickSubItem (sub, $event) {
      let checked = $event.target.checked;
      let that = this;
      let len = 0;
      if (checked) {
        sub.productItems.forEach(item => {
          if (that.checkedItemList.indexOf(item.itemId) >= 0) {
            len++;
          }
        });
        if (sub.productItems.length === len) {
          that.checkedList.push(sub.subId);
        }
      } else {
        that.checkedList.splice(that.checkedList.indexOf(sub.subId), 1);
      }
    },
    getProductQuantity () {
      let param = {
        params: {
          groupId: this.configurationGroup.groupId
        }
      };
      Api.getProductQuantity(param)
        .then(result => {
          if (result.data.status === '200') {
            this.productQuantity = result.data.data;
          }
        })
        .catch(error => {
          console.error('AddedProduct.vue error', error);
        });
    }
  },
  watch: { // 深度 watcher
    'checkedList': {
      handler: function (val, oldVal) {
        this.checked = val.length === this.groupSubItemDListVOList.length;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
  .shoppingCart{
    text-align: left!important;
    color: #ffffff;
    cursor: pointer;
    .show-hide{
      transition: right 0.3s ease-in-out;
      position: fixed;
      right: 0;
      bottom: 100px;
      z-index: 1200;
      width: 50px;
      height: 50px;
      text-align: center;
      padding: 0;
      margin: 0;
      background: #36bade;
      img{
        width: 30px;
        margin-top: 10px;
      }
      &.active{
        right: 420px;
      }
      .total-number{
        position: absolute;
        display: inline-block;
        background: #ed1940;
        border-radius: 50%;
        padding: 4px;
        right: 0;
        top: -10px;
        min-width: 26px;
      }
    }
    .rj-drawer__header{
      background: #36bade;
      .rj-drawer__header-title{
        color: #ffffff;
      }
    }
    .rj-drawer__body{
      padding-bottom: 100px;
      position: relative;
    }

    .series-content{
      color: #606266;
      font-size: 14px;
      margin-bottom: 20px;
      .series{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #e4e7ed;
        .series-name{
          margin-left: 10px;
        }
      }
      .version-content{
        margin-top: 10px;
        margin-bottom: 10px;
        .version-name{
          margin-left: 10px;
        }
        .version-number{
          padding-left: 24px;
          margin-top: 4px;
          margin-bottom: 4px;
          height: 30px;
          line-height: 30px;
          position: relative;
          .number{
            margin-right: 10px;
          }
          .del-icon{
            position: absolute;
            right: 0;
            top: 4px;
            width: 30px;
            .el-icon-delete{
              font-size: 18px;
              color: red;
              cursor:pointer;
            }
          }
        }
      }
    }
    .operation{
      position: fixed;
      bottom: 0;
      width: 100%;
      background: #ffffff;
      z-index: 1020;
      height: 80px;
      line-height: 80px;
      border-top:1px solid #e4e7ed;
      .el-button--primary.is-plain{
        color: #36BAD9;
      }
      .el-button--primary {
        background: rgba(54,186,222,0.2)!important;
      }
    }
  }
</style>

<style scoped>
.select-text{
  position: relative;
  top: -2px;
  color: #000;
}
</style>
